import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';

import store from '../../store';

@customElement('family-overview')
export class FamilyOverview extends connect(store)(LitElement) {

	static styles = [
		css`
	:host {
		margin: 0 var(--specsheet-large-gap) var(--specsheet-medium-gap) var(--specsheet-large-gap);
	}

	.familyDescription p {
		font: var(--font-specsheet-headline);
	}

	.shortDescription p {
		font: var(--font-specsheet-small-text);
	}

	.imageSection {
		max-width: 100%;
		height: 100%;
		margin-top: 30px;
	}

	.fullImage {
		width: 100%;
		margin-bottom: 20px;
		height: 550px;
		object-fit: cover;
	}

	.imagesContainer {
		height: 100%;
		display: flex;
	}

	.img {
		width: 49%;
		height: 100%;
		margin-right: 20px;
		object-fit: cover;
	}

	.img:last-child {
		margin-right: 0;
	}

	.shortDescription {
		width: 50%;
		margin-top: 10px;
		margin-bottom: 40px;
	}


	@media print {
		:host {
			width: 100vw;
			margin: 0;
		}

		.imageSection {
			max-width: 100%;
			height: 100%;
		}

		.fullImage {
			width: 100%;
			margin-bottom: 10px;
			height: 35vh;
			object-fit: cover;
		}

		.imagesContainer {
			height: 20vh;
			display: flex;
		}

		.img {
			width: 49%;
			height: 100%;
			margin-right: 20px;
			object-fit: cover;
		}

		.img:last-child {
			margin-right: 0;
		}

		.shortDescription {
			width: 50%;
			margin-top: 10px;
		}

		.familyDescription p {
			font: var(--font-specsheet-print-headline);
			margin-top: 0px;
			margin-bottom: 0px;
		}

		.shortDescription p {
			font: var(--font-specsheet-print-small-text);
		}
	}

	`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
	}

	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
        <div class="familyOverview">
			<section class="familyDescription">
				<p>${this.kirbySpecsheet.family_intro}</p>
			</section>

			<section class="imageSection">
				${when(this.kirbySpecsheet.cover_image_big, () => html`
					<img class="fullImage" src=${this.kirbySpecsheet.cover_image_big}/>
				`, () => html``)}
				<div class="imagesContainer">
					${when(this.kirbySpecsheet.cover_image_left, () => html`
						<img class="img" src=${this.kirbySpecsheet.cover_image_left}/>
					`, () => html``)}
					${when(this.kirbySpecsheet.cover_image_right, () => html`
						<img class="img" src=${this.kirbySpecsheet.cover_image_right}/>
					`, () => html``)}
				</div>
			</section>

			<section class="shortDescription">
				<p>${this.kirbySpecsheet.family_description}</p>
			</section>

		</div>
		`;
	}
}
